module.exports = __webpack_public_path__ + "img/SI-main@2x.c39785a.png";